import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { IPickMutation } from "../types";
import { getApi } from "../apiPath";
import { axiosClient, queryClient } from "../clients";

import { useGetAllMembers } from "./getAll";
import type { IMembers } from "./routeType";

const { getPath } = getApi("members.post");

type IExtractedRouteType = IMembers["memberProfileSingleCreate"];

export type IPostMember = IPickMutation<IExtractedRouteType>;

const postMember: MutationFunction<
  IPostMember["response"],
  IPostMember["variables"]
> = (data) => {
  return axiosClient.post(getPath(), data);
};

export const usePostMember = createMutation({
  mutationFn: postMember,
  onSuccess: () => {
    queryClient.invalidateQueries({ queryKey: useGetAllMembers.getKey() });
  },
});
